module.exports = __webpack_public_path__ + "img/qggbg.923d9595.png";